<hidden-map-header/>
<div class="app-container about-values pt-4 pb-5">
  <div class="pdf-container">
    <object
      class="pdf-object"
      data="../hidden-map/website_map.pdf#zoom=fit"
      type="application/pdf">
    </object>
  </div>
</div>
